import styled, { css } from 'styled-components';
import LoanTooltip from '../loan-tooltip/LoanTooltip';
export const ColoredStatusContainer = styled.div `
  position: absolute;

  display: flex;
  justify-content: center;

  padding: ${({ position }) => position === 'left' ? `1rem 2rem 2rem 0` : `1rem 0 2rem 1rem`};
  width: 20rem;

  border-radius: ${({ theme }) => {
    const radius = theme.borderRadius.mediumHigh;
    return `${radius} ${radius} 0 0 `;
}};
  border: ${({ borderColor }) => borderColor ? `1px solid ${borderColor}` : 'none'};
  border-bottom: none;

  ${({ position }) => position === 'left' ? `border-left: none` : `border-right: none`};

  background-color: ${({ theme, backgroundColor }) => backgroundColor || theme.colors.surface.interactiveDefault};

  z-index: 1;

  &:after {
    content: '';

    position: absolute;

    width: 2.5rem;
    height: 100%;

    background-color: ${({ theme, backgroundColor }) => backgroundColor || theme.colors.surface.interactiveDefault};

    border-left: ${({ borderColor }) => borderColor ? `1px solid ${borderColor}` : 'none'};
    z-index: -1;

    ${({ position }) => position === 'left'
    ? css `
            top: -2px;
            left: -1.1rem;
            transform: rotate(30deg);

            border-top-left-radius: ${({ theme }) => theme.borderRadius.mediumHigh};
          `
    : css `
            top: -2.5px;
            right: -12px;
            transform: rotate(150deg);

            border-bottom-left-radius: ${({ theme }) => theme.borderRadius.mediumHigh};
          `}
  }
`;
export const StatusWrapper = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;

  height: 3.4rem;

  padding: 0 2rem;

  border-radius: ${({ theme }) => theme.borderRadius.high};
  border: 1px solid ${({ theme }) => theme.colors.interactive.brandColor};

  background-color: ${({ theme }) => theme.colors.interactive.secondaryDisabled};
`;
export const MainContentWrapper = styled.div `
  width: 100%;
`;
export const CustomLoanTooltip = styled(LoanTooltip) `
  margin-left: 0.9rem;
`;
export const TextWrapper = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const IndicatorWrapper = styled.div `
  position: relative;

  display: flex;
  justify-content: space-between;

  margin-top: 0.8rem;
`;
export const RedIndicatior = styled.div `
  width: 100%;
  max-width: 6rem;
  height: 0.6rem;

  margin-right: 0.4rem;

  border-radius: ${({ theme }) => theme.borderRadius.medium};

  background-color: ${({ theme }) => theme.colors.text.critical};
  opacity: ${({ isActive }) => (isActive ? 1 : 0.2)};
`;
export const YellowIndicatior = styled.div `
  width: 100%;
  max-width: 6rem;
  height: 0.6rem;

  margin-right: 0.4rem;

  border-radius: ${({ theme }) => theme.borderRadius.medium};

  background-color: ${({ theme }) => theme.colors.text.pending};
  opacity: ${({ isActive }) => (isActive ? 1 : 0.2)};
`;
export const GreenIndicatior = styled.div `
  width: 100%;
  max-width: 6rem;
  height: 0.6rem;

  border-radius: ${({ theme }) => theme.borderRadius.medium};

  background-color: ${({ theme }) => theme.colors.text.success};
  opacity: ${({ isActive }) => (isActive ? 1 : 0.2)};
`;
export const ProgressInticator = styled.div `
  position: absolute;
  top: calc(50% - 0.6rem);
  left: ${({ currentProgress }) => `calc((100% - 0.6rem) * ${1 - (currentProgress || 0)})`};

  width: 1.2rem;
  height: 1.2rem;

  border: 2px solid ${({ theme }) => theme.colors.surface.default};
  border-radius: ${({ theme }) => theme.borderRadius.highest};

  background-color: ${({ theme }) => theme.colors.text.default};
`;
//# sourceMappingURL=styles.js.map